import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  chartWrapper: {
    width: '100%',
    height: 300,
    marginTop: theme.spacing(1),
  },
}));

interface MonthlyTrendChartProps {
  data: Array<{ month: string; count: number }>;
}

/** Formats "2025-03" → "Mar/25" */
function formatMonth(month: string): string {
  const [year, m] = month.split('-');
  const months = [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
  ];
  const idx = parseInt(m, 10) - 1;
  return `${months[idx] ?? m}/${year.slice(2)}`;
}

const BAR_COLORS = [
  '#1976d2', '#388e3c', '#f57c00', '#d32f2f', '#7b1fa2',
  '#00838f', '#c62828', '#4527a0', '#2e7d32', '#ef6c00',
  '#1565c0', '#6a1b9a',
];

export const MonthlyTrendChart = ({ data }: MonthlyTrendChartProps) => {
  const classes = useStyles();

  const chartData = data.map(d => ({
    name: formatMonth(d.month),
    deploys: d.count,
  }));

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Deployments por Mês
        </Typography>
        {chartData.length === 0 ? (
          <Typography color="textSecondary" variant="body2">
            Nenhum dado disponível
          </Typography>
        ) : (
          <div className={classes.chartWrapper}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" fontSize={12} />
                <YAxis allowDecimals={false} fontSize={12} />
                <Tooltip />
                <Bar dataKey="deploys" name="Deploys" radius={[4, 4, 0, 0]}>
                  {chartData.map((_entry, index) => (
                    <Cell key={index} fill={BAR_COLORS[index % BAR_COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
